import React from 'react';

const DownloadPDF: React.FC<{ width?: string; height?: string; fill?: string }> = ({
  width = '24px',
  height = '24px',
  fill = '#F1F1F1',
}): React.ReactElement => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 0H15H16.5H16.5031L21.75 5.36614V24H3.75V21H5.25V22.5H20.25V6.75H15V1.5H5.25V13.5H3.75V0ZM16.5 5.25V2.14282L19.538 5.25H16.5ZM2.25 14.25H12.75V20.25H2.25V14.25ZM4.35 18.75V17.6796H4.758C5.1228 17.6796 5.402 17.5964 5.5956 17.43C5.7892 17.2636 5.886 17.0236 5.886 16.71C5.886 16.5404 5.8516 16.3892 5.7828 16.2564C5.714 16.1236 5.6172 16.0156 5.4924 15.9324C5.39 15.8652 5.2716 15.8164 5.1372 15.786C5.0028 15.7556 4.8348 15.7404 4.6332 15.7404H3.75V18.75H4.35ZM4.6716 17.2284H4.35V16.2156H4.686C4.8748 16.2156 5.0164 16.2556 5.1108 16.3356C5.2052 16.4156 5.2524 16.5436 5.2524 16.7196C5.2524 16.8956 5.2044 17.0244 5.1084 17.106C5.0124 17.1876 4.8668 17.2284 4.6716 17.2284ZM8.1852 18.5436C7.9484 18.6812 7.646 18.75 7.278 18.75H6.3372V15.7404H7.158C7.4172 15.7404 7.6252 15.7564 7.782 15.7884C7.9388 15.8204 8.0764 15.8716 8.1948 15.942C8.406 16.07 8.5668 16.2436 8.6772 16.4628C8.7876 16.682 8.8428 16.942 8.8428 17.2428C8.8428 17.5436 8.7868 17.8052 8.6748 18.0276C8.5628 18.25 8.3996 18.422 8.1852 18.5436ZM7.2492 18.2748H6.9372V16.2156H7.2348C7.5676 16.2156 7.8076 16.3052 7.9548 16.4844C8.0316 16.574 8.0908 16.686 8.1324 16.8204C8.174 16.9548 8.1948 17.0908 8.1948 17.2284C8.1948 17.4236 8.1764 17.586 8.1396 17.7156C8.1028 17.8452 8.0412 17.9516 7.9548 18.0348C7.862 18.1244 7.7588 18.1868 7.6452 18.222C7.5316 18.2572 7.3996 18.2748 7.2492 18.2748ZM9.918 17.5164V18.75H9.318V15.7404H11.166L11.022 16.2156H9.918V17.0412H10.9308L10.8204 17.5164H9.918Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default DownloadPDF;
